import DateInput from "@/components/Common/DateInput/DateInput.vue";
import { DateTime } from "luxon";
import TimeInput from "@/components/Common/TimeInput/TimeInput.vue";
import DurationInput from "@/components/Events/DurationInput/DurationInput.vue";
import axios from "axios";
import { getTokenHeader } from "@/helpers/commonHelper";
import { debounce } from "lodash";
const headers = getTokenHeader();
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import { getDateRange, getHolidays, states } from "@/helpers/holidaysHelper.js";
import { dateFormat, formatToTime } from "@/helpers/eventHelper";
export default {
  name: "EventSet",
  components: { DurationInput, TimeInput, DateInput },
  data: () => ({
    intervalItems: [
      { text: "wöchentlich", value: "weekly" },
      { text: "jede zweite Woche", value: "every_2nd_week" },
      { text: "jede dritte Woche", value: "every_3nd_week" },
      { text: "jede vierte Woche", value: "every_4th_week" }
    ],
    query: {
      start: new Date().toISOString(),
      end: "",
      entry: "",
      time: "10:00",
      duration: 0, //minutes
      allDay: false,
      weekDays: [], //days: Mon, Tue, Wed, Thu, Fri, Sat, Sun
      excludeDays: [],
      interval: "weekly"
      // interval: 'every_2nd_week',
      // interval: 'every_4th_week',
    },
    excludePublicHolidays: false,
    excludeSchoolHolidays: false,
    sortedDates: [],
    previewDates: [],
    newDates: null,
    debouncedWatch: null,
    loading: false,
    selectedState: "BY",
    states,
    holidayQueryHash: "",
    endTime: ""
  }),
  props: ["editedEvent", "dialog", "moments", "lastDate"],
  computed: {
    show: {
      get() {
        return this.dialog;
      },
      set(dialog) {
        if (!dialog) {
          this.debouncedWatch.cancel();
          this.previewDates = [];
          this.$emit("close");
          return;
        }
        this.initValues();
      }
    }
  },
  methods: {
    async getExcludeHolidays() {
      const exclude = [];
      const query = {
        from: this.query.start,
        to: this.query.end,
        subdivisionCode: this.selectedState
      };
      const addExclude = results => {
        results.forEach(holiday => {
          exclude.push(
            getDateRange({ from: holiday.startDate, to: holiday.endDate })
          );
        });
      };
      if (this.excludeSchoolHolidays)
        addExclude(await this.getSchoolHolidays(query));
      if (this.excludePublicHolidays)
        addExclude(await this.getPublicHolidays(query));
      return exclude.flat();
    },
    async getPublicHolidays(data) {
      data.type = "PublicHolidays";
      return await getHolidays(data, () =>
        this.$store.dispatch("createError", {
          text: "openholidaysapi.org evtl. nicht erreichbar."
        })
      );
    },
    async getSchoolHolidays(data) {
      data.type = "SchoolHolidays";
      return await getHolidays(data, () =>
        this.$store.dispatch("createError", {
          text: "openholidaysapi.org evtl. nicht erreichbar."
        })
      );
    },
    setDays(days) {
      let allDays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
      // all/reset selected?
      const all = this.query.weekDays.includes("all");
      if (this.query.weekDays.includes("reset")) {
        this.query.weekDays = ["Sun"];
        return;
      }
      // sorting
      this.query.weekDays = allDays
        .map(day => (days.includes(day) || all ? day : null))
        .filter(d => !!d);
    },
    async calculateDates(data) {
      if (!this.query.start || !this.query.end || !this.query.weekDays.length) {
        this.previewDates = [];
        return;
      }
      if (!this.query.interval) {
        this.query.interval = "weekly";
      }
      this.loading = true;
      localStorage.setItem("selectedHolidayState", this.selectedState);
      const holidayQueryHash =
        this.query.start +
        "-" +
        this.query.end +
        "-" +
        this.selectedState +
        (this.excludePublicHolidays ? "pub" : "") +
        (this.excludeSchoolHolidays ? "sch" : "");
      let excludeDays = [];
      // only update if holiday-query changes
      if (holidayQueryHash !== this.holidayQueryHash) {
        excludeDays = await this.getExcludeHolidays();
      }
      this.holidayQueryHash = holidayQueryHash;
      try {
        const res = await axios.post(
          `${env.events_api_client_url}event/calculateDates`,
          { ...data, excludeDays },
          {
            headers
          }
        );
        const momentStrings = this.moments.map(d => dateFormat(d.from));
        this.newDates = res.data.map(m => {
          return {
            ...m,
            overlapping: momentStrings.includes(dateFormat(m.from))
          };
        });
        this.sortedDates = [...this.moments, ...this.newDates].sort(
          (a, b) => new Date(a.from) - new Date(b.from)
        );
        this.previewDates = [...this.sortedDates]
          //filter outdated events
          .filter(d => new Date(d.from) > new Date());
        if (this.previewDates.every(d => d._id)) {
          //nothing new
          this.previewDates = [];
        }
      } catch (error) {
        this.newDates = [];
        console.error(error);
        await this.$store.dispatch("createError", error);
      }
      this.loading = false;
    },
    dateFormat,
    formatToTime,
    addEventSet() {
      this.$emit(
        "addEventSet",
        this.sortedDates.filter(d => !d.overlapping)
      );
      this.previewDates = null;
      this.newDates = null;
      this.show = false;
    },
    setEventSetEndTime(time) {
      const [hour, minute] = this.query.time.split(":");
      const [hourEnd, minuteEnd] = time.split(":");

      this.endTime = DateTime.fromISO(this.query.time)
        .set({ hour: hourEnd, minute: minuteEnd })
        .toFormat("HH:mm");

      this.query.duration = DateTime.fromISO(this.endTime)
        .diff(DateTime.fromISO(this.endTime).set({ hour, minute }), "minutes")
        .toObject().minutes;
    },
    initValues() {
      if (!this.editedEvent.start) return;
      this.query.weekDays = [];
      // select start day for interval
      // this.query.weekDays.push(
      //   DateTime.fromISO(this.editedEvent.start).toFormat("ccc")
      // );
      this.query.time = DateTime.fromISO(this.editedEvent.start).toFormat(
        "HH:mm"
      );
      this.query.allDay = this.editedEvent.all_day;
      const lastDate = this.lastDate || this.editedEvent.start;
      this.query.start = new Date(lastDate).toISOString();
      this.query.end = DateTime.fromISO(lastDate)
        .plus({ days: 14 })
        .toJSON();
      this.selectedState = localStorage.getItem("selectedHolidayState") || "BY";
    }
  },
  watch: {
    query: {
      deep: true,
      handler() {
        if (this.previewDates?.length && !this.dialog) return;
        if (!this.debouncedWatch) {
          this.debouncedWatch = debounce(() => {
            this.calculateDates(this.query);
          }, 100);
        }
        this.debouncedWatch();
      }
    },
    dialog: {
      handler(dialog) {
        if (dialog) {
          this.initValues();
        }
      }
    }
  },
  mounted() {
    this.initValues();
  }
};
